var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 485.319,
    height: 279.14,
    viewBox: "0 0 485.319 279.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.004,
    y1: -0.272,
    x2: 0.996,
    y2: 1.272,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.004,
    y1: -0.272,
    x2: 0.996,
    y2: 1.272,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#09f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1128",
    x: 128.319,
    y: 6.289,
    width: 357,
    height: 162,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -20,
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2578",
    "data-name": "Group 2578",
    transform: "translate(-190.681 -46.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2522",
    "data-name": "Group 2522",
    transform: "matrix(1, 0.017, -0.017, 1, 14.358, -249.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2508",
    "data-name": "Group 2508",
    transform: "translate(364.28 370.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    d: "M351.359,379.067,324.321,366.1a21.38,21.38,0,0,0-.828,5.863l.011-.011c.113,3.415,2.454,6.829,6.984,9.447,5.7,3.294,13.554,4.578,20.871,3.837Z",
    transform: "translate(-323.492 -358.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_363",
    "data-name": "Line 363",
    x2: 19.375,
    y2: 3.046,
    transform: "translate(8.493 23.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M338.831,363.543",
    transform: "translate(-295.614 -363.543)",
    fill: "#bcbec0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2521",
    "data-name": "Group 2521",
    transform: "translate(301.048 359.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2512",
    "data-name": "Group 2512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2509",
    "data-name": "Group 2509",
    transform: "translate(2.623 36.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M430.58,407.25c-1.589-8.077-7.745-15.907-18.476-22.1-25.19-14.549-66.034-14.549-91.229,0-10.8,6.229-16.972,14.123-18.507,22.257l-.386-.161v4.468h0c.1,9.455,6.4,18.888,18.891,26.1,25.2,14.546,66.039,14.546,91.229,0,12.6-7.269,18.9-16.8,18.9-26.334V407.25ZM326.222,388.233a8.558,8.558,0,0,1,7.734,0l15.78,9.117c2.141,1.228,2.141,3.229,0,4.463a8.547,8.547,0,0,1-7.736,0L326.222,392.7C324.081,391.47,324.081,389.467,326.222,388.233Zm-11.213,26.41c-3.026,0-5.471-1.414-5.471-3.161s2.445-3.158,5.471-3.158h22.316c3.026,0,5.474,1.414,5.474,3.158s-2.448,3.161-5.477,3.161Zm34.727,10.985-15.78,9.106a8.506,8.506,0,0,1-7.734,0c-2.141-1.231-2.141-3.234,0-4.468L342,421.154a8.529,8.529,0,0,1,7.736,0C351.877,422.388,351.877,424.388,349.735,425.628Zm11.284-43.864c0-1.75,2.445-3.167,5.469-3.167s5.483,1.417,5.483,3.167v12.884c0,1.747-2.462,3.158-5.483,3.158s-5.469-1.411-5.469-3.158Zm5.469,62.6c-3.02,0-5.469-1.42-5.469-3.161V428.319c0-1.738,2.445-3.153,5.469-3.153s5.483,1.414,5.483,3.153v12.889C371.97,442.949,369.508,444.369,366.488,444.369Zm16.755-47.019,15.777-9.117a8.57,8.57,0,0,1,7.739,0c2.141,1.234,2.141,3.237,0,4.471l-15.772,9.109a8.564,8.564,0,0,1-7.745,0C381.1,400.579,381.1,398.578,383.242,397.35Zm23.517,37.384a8.517,8.517,0,0,1-7.739,0l-15.777-9.106c-2.141-1.24-2.141-3.237,0-4.474a8.547,8.547,0,0,1,7.745,0l15.772,9.111C408.9,431.5,408.9,433.5,406.759,434.734Zm11.21-20.091H395.653c-3.023,0-5.469-1.414-5.469-3.161s2.446-3.158,5.469-3.158h22.316c3.029,0,5.48,1.414,5.48,3.158S421,414.643,417.969,414.643Z",
    transform: "translate(-301.975 -370.003)",
    fill: "#535359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M412.107,383.645c-25.19-14.543-66.034-14.543-91.229,0s-25.2,38.13,0,52.676,66.039,14.543,91.229,0S437.306,398.191,412.107,383.645ZM326.225,391.2c-2.141-1.234-2.141-3.231,0-4.468a8.541,8.541,0,0,1,7.734,0l15.78,9.109c2.141,1.234,2.141,3.232,0,4.474a8.564,8.564,0,0,1-7.736,0Zm11.1,21.942H315.012c-3.026,0-5.471-1.412-5.471-3.164s2.445-3.158,5.471-3.158h22.316c3.026,0,5.474,1.417,5.474,3.158S340.354,413.143,337.326,413.143Zm29.165-16.834c-3.023,0-5.469-1.417-5.469-3.164V380.267c0-1.755,2.445-3.167,5.469-3.167s5.483,1.411,5.483,3.167v12.878C371.974,394.892,369.511,396.309,366.491,396.309Zm-32.532,36.927a8.558,8.558,0,0,1-7.734,0c-2.141-1.237-2.141-3.237,0-4.468L342,419.657a8.547,8.547,0,0,1,7.736,0c2.141,1.231,2.141,3.234,0,4.471Zm57.032-32.921a8.582,8.582,0,0,1-7.745,0c-2.141-1.242-2.141-3.24,0-4.474l15.777-9.109a8.553,8.553,0,0,1,7.739,0c2.141,1.237,2.141,3.234,0,4.468Zm4.666,6.505h22.316c3.029,0,5.48,1.414,5.48,3.158s-2.451,3.164-5.48,3.164H395.657c-3.023,0-5.469-1.412-5.469-3.164S392.634,406.821,395.657,406.821Zm-29.165,36.043c-3.02,0-5.469-1.414-5.469-3.158V426.821c0-1.744,2.445-3.161,5.469-3.161s5.483,1.417,5.483,3.161v12.887C371.974,441.449,369.511,442.863,366.491,442.863Zm32.532-9.627-15.777-9.109c-2.141-1.237-2.141-3.24,0-4.471a8.565,8.565,0,0,1,7.745,0l15.772,9.111c2.141,1.234,2.141,3.232,0,4.468A8.57,8.57,0,0,1,399.023,433.236Z",
    transform: "translate(-301.979 -372.738)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M353.289,396.973a12.512,12.512,0,0,0-3.789-3.192c-7.108-4.108-18.642-4.108-25.748,0a12.554,12.554,0,0,0-3.8,3.192c-2.939-3.849-1.671-8.511,3.8-11.667,7.105-4.1,18.64-4.1,25.748,0C354.971,388.461,356.231,393.124,353.289,396.973Z",
    transform: "translate(-272.11 -355.491)",
    fill: "#535359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M352.3,391.507a12.65,12.65,0,0,1-3.789,3.2c-7.108,4.1-18.643,4.1-25.748,0a12.728,12.728,0,0,1-3.8-3.2,12.554,12.554,0,0,1,3.8-3.192c7.105-4.108,18.64-4.108,25.748,0A12.512,12.512,0,0,1,352.3,391.507Z",
    transform: "translate(-271.116 -350.026)",
    fill: "#303033"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2510",
    "data-name": "Group 2510",
    transform: "translate(10.087 8.315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M420.709,374.578v31.851c0,8.636-5.7,17.27-17.035,23.759-22.613,13.139-59.391,13.139-82.085,0-11.337-6.49-16.958-15.123-16.958-23.759V374.578Z",
    transform: "translate(-305.589 -340.65)",
    fill: "#fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M418.719,377.954c-.017,8.418-5.592,16.828-16.718,23.24-22.229,12.949-58.381,12.949-80.684,0-10.878-6.274-16.436-14.464-16.684-22.7v1.6c0,8.483,5.525,16.969,16.668,23.353,22.305,12.915,58.455,12.915,80.681,0,11.143-6.384,16.744-14.87,16.744-23.353v-2.136Z",
    transform: "translate(-304.621 -335.497)",
    fill: "#e5d600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M418.719,379.9c-.017,8.413-5.592,16.825-16.718,23.235-22.229,12.951-58.381,12.951-80.684,0-10.878-6.28-16.436-14.47-16.684-22.705v1.6c0,8.489,5.525,16.972,16.668,23.353,22.305,12.92,58.455,12.92,80.681,0,11.143-6.381,16.744-14.864,16.744-23.353V379.9Z",
    transform: "translate(-304.621 -331.968)",
    fill: "#e5d600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M418.719,381.835c-.017,8.415-5.592,16.828-16.718,23.235-22.229,12.954-58.381,12.954-80.684,0-10.878-6.269-16.436-14.464-16.684-22.7v1.6c0,8.483,5.525,16.966,16.668,23.35,22.305,12.915,58.455,12.915,80.681,0,11.143-6.384,16.744-14.867,16.744-23.35v-2.138Z",
    transform: "translate(-304.621 -328.444)",
    fill: "#e5d600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M418.719,383.776c-.017,8.41-5.592,16.823-16.718,23.235-22.229,12.951-58.381,12.951-80.684,0-10.878-6.274-16.436-14.467-16.684-22.705v1.606c0,8.48,5.525,16.966,16.668,23.35,22.305,12.915,58.455,12.915,80.681,0,11.143-6.384,16.744-14.87,16.744-23.35v-2.136Z",
    transform: "translate(-304.621 -324.916)",
    fill: "#e5d600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M321.323,419.065c22.3,12.951,58.455,12.951,80.684,0,22.3-12.839,22.3-33.713,0-46.551-22.229-12.839-58.381-12.839-80.684,0C299.063,385.352,299.063,406.226,321.323,419.065Z",
    transform: "translate(-304.628 -362.884)",
    fill: "#ba6000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M321.607,415.565c20.542,11.929,53.837,11.929,74.322,0,20.539-11.836,20.539-31.059,0-42.889-20.485-11.827-53.781-11.827-74.322,0C301.1,384.506,301.1,403.729,321.607,415.565Z",
    transform: "translate(-301.728 -361.21)",
    fill: "#ff9d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M321.814,412.9c19.22,11.165,50.366,11.165,69.519,0,19.212-11.061,19.212-29.047,0-40.105-19.152-11.058-50.3-11.058-69.519,0C302.639,383.855,302.639,401.841,321.814,412.9Z",
    transform: "translate(-299.532 -359.942)",
    fill: "#ba6000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M321.986,410.816c18.147,10.54,47.563,10.54,65.65,0,18.149-10.447,18.149-27.43,0-37.877-18.087-10.45-47.5-10.45-65.65,0C303.876,383.386,303.876,400.369,321.986,410.816Z",
    transform: "translate(-297.768 -358.853)",
    fill: "#ff9d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M322.168,408.554c17.031,9.895,44.644,9.895,61.627,0,17.034-9.807,17.034-25.745,0-35.552-16.983-9.81-44.6-9.81-61.627,0C305.159,382.809,305.159,398.747,322.168,408.554Z",
    transform: "translate(-295.936 -357.868)",
    fill: "#ba6000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M322.313,406.707c16.09,9.34,42.168,9.34,58.207,0,16.082-9.261,16.082-24.32,0-33.586-16.039-9.258-42.117-9.258-58.207,0C306.259,382.387,306.259,397.446,322.313,406.707Z",
    transform: "translate(-294.371 -356.899)",
    fill: "#ff9d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M322.46,404.812c15.157,8.8,39.722,8.8,54.82,0,15.157-8.731,15.157-22.914,0-31.636-15.1-8.725-39.663-8.725-54.82,0C307.342,381.9,307.342,396.081,322.46,404.812Z",
    transform: "translate(-292.828 -356.075)",
    fill: "#ba6000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M322.6,403.165c14.309,8.3,37.511,8.3,51.778,0,14.309-8.246,14.309-21.643,0-29.878-14.267-8.244-37.468-8.244-51.778,0C308.312,381.522,308.312,394.919,322.6,403.165Z",
    transform: "translate(-291.442 -355.214)",
    fill: "#ff9d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M322.739,401.375c13.439,7.8,35.211,7.8,48.6,0,13.436-7.734,13.436-20.31,0-28.041-13.391-7.734-35.164-7.734-48.6,0C309.328,381.064,309.328,393.641,322.739,401.375Z",
    transform: "translate(-289.993 -354.435)",
    fill: "#ba6000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M322.857,399.913c12.689,7.367,33.259,7.367,45.9,0,12.687-7.305,12.687-19.183,0-26.483-12.644-7.3-33.214-7.3-45.9,0C310.193,380.73,310.193,392.608,322.857,399.913Z",
    transform: "translate(-288.762 -353.672)",
    fill: "#ff9d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M322.965,398.529c12.008,6.973,31.476,6.973,43.444,0,12.008-6.914,12.008-18.152,0-25.066-11.968-6.908-31.436-6.908-43.444,0C310.98,380.377,310.98,391.615,322.965,398.529Z",
    transform: "translate(-287.639 -353.074)",
    fill: "#ba6000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M323.073,397.225c11.334,6.584,29.726,6.584,41.029,0,11.337-6.525,11.337-17.141,0-23.669-11.3-6.533-29.7-6.533-41.029,0S311.752,390.7,323.073,397.225Z",
    transform: "translate(-286.538 -352.395)",
    fill: "#ff9d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M323.183,395.883c10.678,6.2,27.991,6.2,38.637,0,10.684-6.147,10.684-16.146,0-22.291-10.647-6.153-27.96-6.153-38.637,0S312.513,389.735,323.183,395.883Z",
    transform: "translate(-285.451 -351.812)",
    fill: "#ba6000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M323.274,394.726c10.086,5.857,26.438,5.857,36.491,0,10.092-5.807,10.092-15.256,0-21.06-10.052-5.809-26.4-5.809-36.491,0S313.2,388.92,323.274,394.726Z",
    transform: "translate(-284.471 -351.207)",
    fill: "#ff9d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M323.371,393.47c9.466,5.5,24.821,5.5,34.259,0,9.472-5.454,9.472-14.318,0-19.769-9.438-5.452-24.793-5.452-34.259,0S313.919,388.016,323.371,393.47Z",
    transform: "translate(-283.45 -350.658)",
    fill: "#ba6000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M323.453,392.44c8.945,5.19,23.44,5.19,32.352,0,8.948-5.153,8.948-13.521,0-18.673-8.911-5.145-23.407-5.145-32.352,0C314.528,378.92,314.528,387.287,323.453,392.44Z",
    transform: "translate(-282.582 -350.119)",
    fill: "#ff9d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M323.59,390.7c8.069,4.682,21.13,4.682,29.168,0,8.061-4.637,8.061-12.188,0-16.828-8.038-4.637-21.1-4.637-29.168,0C315.547,378.509,315.547,386.059,323.59,390.7Z",
    transform: "translate(-281.131 -349.243)",
    fill: "#ba6000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M321.323,419.065c22.3,12.951,58.455,12.951,80.684,0,22.3-12.839,22.3-33.713,0-46.551-22.229-12.839-58.381-12.839-80.684,0C299.063,385.352,299.063,406.226,321.323,419.065Z",
    transform: "translate(-304.628 -362.884)",
    opacity: 0.84
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2511",
    "data-name": "Group 2511",
    transform: "translate(2.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M430.58,394.448c-1.589-8.077-7.745-15.912-18.476-22.1-25.19-14.541-66.034-14.541-91.229,0-10.8,6.238-16.972,14.132-18.507,22.26l-.386-.155v4.471h0c.1,9.449,6.4,18.885,18.891,26.1,25.2,14.543,66.039,14.543,91.229,0,12.6-7.274,18.9-16.806,18.9-26.34v-4.232ZM326.222,375.43a8.541,8.541,0,0,1,7.734,0l15.78,9.106c2.141,1.24,2.141,3.237,0,4.474a8.547,8.547,0,0,1-7.736,0L326.222,379.9C324.081,378.665,324.081,376.667,326.222,375.43Zm-11.213,26.41c-3.026,0-5.471-1.411-5.471-3.161s2.445-3.161,5.471-3.161h22.316c3.026,0,5.474,1.417,5.474,3.161s-2.448,3.161-5.477,3.161Zm34.727,10.982-15.78,9.111a8.559,8.559,0,0,1-7.734,0c-2.141-1.237-2.141-3.237,0-4.466L342,408.351a8.564,8.564,0,0,1,7.736,0C351.877,409.585,351.877,411.589,349.735,412.823Zm11.284-43.866c0-1.744,2.445-3.158,5.469-3.158s5.483,1.414,5.483,3.158v12.887c0,1.744-2.462,3.161-5.483,3.161s-5.469-1.417-5.469-3.161Zm5.469,62.608c-3.02,0-5.469-1.414-5.469-3.164V415.519c0-1.752,2.445-3.164,5.469-3.164s5.483,1.417,5.483,3.164V428.4C371.97,430.149,369.508,431.564,366.488,431.564Zm16.755-47.028,15.777-9.106a8.553,8.553,0,0,1,7.739,0c2.141,1.237,2.141,3.234,0,4.468l-15.772,9.111a8.564,8.564,0,0,1-7.745,0C381.1,387.773,381.1,385.776,383.242,384.536Zm23.517,37.4a8.57,8.57,0,0,1-7.739,0l-15.777-9.111c-2.141-1.234-2.141-3.237,0-4.471a8.582,8.582,0,0,1,7.745,0l15.772,9.117C408.9,418.7,408.9,420.7,406.759,421.934Zm11.21-20.094H395.653c-3.023,0-5.469-1.417-5.469-3.161s2.446-3.161,5.469-3.161h22.316c3.029,0,5.48,1.414,5.48,3.161S421,401.84,417.969,401.84Z",
    transform: "translate(-301.975 -357.198)",
    fill: "#535359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M412.107,370.842c-25.19-14.546-66.034-14.546-91.229,0s-25.2,38.13,0,52.671,66.039,14.546,91.229,0S437.306,385.388,412.107,370.842ZM326.225,378.4c-2.141-1.234-2.141-3.237,0-4.468a8.506,8.506,0,0,1,7.734,0l15.78,9.106c2.141,1.24,2.141,3.237,0,4.468a8.512,8.512,0,0,1-7.736,0Zm11.1,21.947H315.012c-3.026,0-5.471-1.426-5.471-3.164s2.445-3.164,5.471-3.164h22.316c3.026,0,5.474,1.414,5.474,3.164S340.354,400.346,337.326,400.346ZM366.491,383.5c-3.023,0-5.469-1.417-5.469-3.155V367.453c0-1.741,2.445-3.161,5.469-3.161s5.483,1.42,5.483,3.161v12.889C371.974,382.081,369.511,383.5,366.491,383.5Zm-32.532,36.933a8.558,8.558,0,0,1-7.734,0c-2.141-1.234-2.141-3.237,0-4.471L342,406.851a8.547,8.547,0,0,1,7.736,0c2.141,1.234,2.141,3.234,0,4.465ZM390.991,387.5a8.53,8.53,0,0,1-7.745,0c-2.141-1.231-2.141-3.229,0-4.468l15.777-9.106a8.518,8.518,0,0,1,7.739,0c2.141,1.231,2.141,3.234,0,4.468Zm4.666,6.514h22.316c3.029,0,5.48,1.414,5.48,3.164s-2.451,3.164-5.48,3.164H395.657c-3.023,0-5.469-1.426-5.469-3.164S392.634,394.018,395.657,394.018Zm-29.165,36.045c-3.02,0-5.469-1.414-5.469-3.167V414.016c0-1.747,2.445-3.161,5.469-3.161s5.483,1.414,5.483,3.161V426.9C371.974,428.649,369.511,430.064,366.491,430.064Zm32.532-9.633-15.777-9.114c-2.141-1.231-2.141-3.232,0-4.465a8.565,8.565,0,0,1,7.745,0l15.772,9.109c2.141,1.234,2.141,3.237,0,4.471A8.57,8.57,0,0,1,399.023,420.431Z",
    transform: "translate(-301.979 -359.933)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M353.289,384.169a12.637,12.637,0,0,0-3.789-3.195c-7.108-4.108-18.642-4.108-25.748,0a12.68,12.68,0,0,0-3.8,3.195c-2.939-3.851-1.671-8.517,3.8-11.664,7.105-4.11,18.64-4.11,25.748,0C354.971,375.657,356.231,380.317,353.289,384.169Z",
    transform: "translate(-272.11 -342.688)",
    fill: "#535359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M352.3,378.7a12.563,12.563,0,0,1-3.789,3.2c-7.108,4.1-18.643,4.1-25.748,0a12.641,12.641,0,0,1-3.8-3.2,12.681,12.681,0,0,1,3.8-3.195c7.105-4.108,18.64-4.108,25.748,0A12.638,12.638,0,0,1,352.3,378.7Z",
    transform: "translate(-271.116 -337.223)",
    fill: "#303033"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2516",
    "data-name": "Group 2516",
    transform: "translate(136.938 31.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2513",
    "data-name": "Group 2513",
    transform: "translate(2.626 36.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M475.643,418.614c-1.592-8.077-7.753-15.907-18.476-22.1-25.19-14.543-66.039-14.543-91.229,0-10.8,6.238-16.972,14.132-18.513,22.257l-.389-.155v4.471h0c.107,9.452,6.4,18.888,18.9,26.1,25.19,14.543,66.039,14.543,91.229,0,12.6-7.274,18.893-16.806,18.893-26.334v-4.237ZM371.274,399.6a8.558,8.558,0,0,1,7.742,0l15.783,9.108c2.13,1.237,2.13,3.237,0,4.474a8.587,8.587,0,0,1-7.748,0l-15.777-9.114C369.138,402.834,369.138,400.834,371.274,399.6Zm-11.2,26.413c-3.026,0-5.474-1.412-5.474-3.158s2.448-3.164,5.474-3.164h22.314c3.023,0,5.474,1.412,5.474,3.164s-2.451,3.158-5.474,3.158Zm34.73,10.979L379.016,446.1a8.558,8.558,0,0,1-7.742,0c-2.133-1.234-2.133-3.237,0-4.468l15.777-9.117a8.588,8.588,0,0,1,7.748,0C396.934,433.755,396.929,435.758,394.8,436.989Zm11.272-43.861c0-1.75,2.454-3.164,5.483-3.164s5.471,1.414,5.466,3.164l.006,12.881c0,1.744-2.451,3.161-5.471,3.161s-5.483-1.417-5.483-3.161Zm5.483,62.6c-3.029,0-5.483-1.414-5.483-3.155V439.688c0-1.744,2.454-3.161,5.483-3.161s5.471,1.417,5.471,3.161v12.887C417.025,454.316,414.574,455.73,411.554,455.73ZM428.3,408.706,444.08,399.6a8.552,8.552,0,0,1,7.739,0c2.138,1.237,2.138,3.237,0,4.468l-15.777,9.114a8.581,8.581,0,0,1-7.745,0C426.167,411.943,426.167,409.942,428.3,408.706Zm23.522,37.4a8.553,8.553,0,0,1-7.739,0L428.3,436.989c-2.136-1.231-2.136-3.234,0-4.471a8.57,8.57,0,0,1,7.739,0l15.777,9.117C453.958,442.866,453.958,444.869,451.82,446.1Zm11.213-20.093H440.714c-3.02,0-5.474-1.412-5.474-3.164s2.454-3.158,5.474-3.158h22.319c3.023,0,5.471,1.412,5.471,3.158S466.056,426.01,463.033,426.01Z",
    transform: "translate(-347.036 -381.368)",
    fill: "#535359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M457.162,395.01c-25.19-14.546-66.039-14.546-91.229,0s-25.193,38.128,0,52.674,66.039,14.54,91.229,0S482.35,409.556,457.162,395.01Zm-85.893,7.553c-2.136-1.234-2.136-3.234,0-4.466a8.541,8.541,0,0,1,7.742,0l15.783,9.106c2.13,1.237,2.13,3.234,0,4.474a8.588,8.588,0,0,1-7.748,0Zm11.109,21.947H360.065c-3.026,0-5.474-1.423-5.474-3.164s2.448-3.167,5.474-3.167h22.314c3.023,0,5.474,1.417,5.474,3.167S385.4,424.511,382.378,424.511Zm29.171-16.845c-3.029,0-5.483-1.414-5.483-3.158V391.624c0-1.747,2.454-3.158,5.483-3.158s5.471,1.412,5.466,3.158l.006,12.884C417.02,406.252,414.569,407.666,411.549,407.666ZM379.011,444.6a8.575,8.575,0,0,1-7.742,0c-2.133-1.234-2.133-3.237,0-4.465l15.777-9.111a8.553,8.553,0,0,1,7.748,0c2.136,1.231,2.13,3.232,0,4.466Zm57.026-32.918a8.564,8.564,0,0,1-7.745,0c-2.13-1.24-2.13-3.237,0-4.474l15.783-9.106a8.535,8.535,0,0,1,7.739,0c2.138,1.231,2.138,3.232,0,4.466Zm4.671,6.5h22.319c3.023,0,5.471,1.417,5.471,3.167s-2.448,3.158-5.471,3.158H440.709c-3.02,0-5.474-1.417-5.474-3.158S437.689,418.18,440.709,418.18Zm-29.16,36.045c-3.029,0-5.483-1.412-5.483-3.158V438.181c0-1.744,2.454-3.158,5.483-3.158s5.471,1.414,5.471,3.158v12.887C417.02,452.814,414.569,454.226,411.549,454.226Zm32.527-9.63L428.3,435.485c-2.136-1.234-2.136-3.234,0-4.466a8.535,8.535,0,0,1,7.739,0l15.777,9.111c2.138,1.228,2.138,3.232,0,4.465A8.569,8.569,0,0,1,444.076,444.6Z",
    transform: "translate(-347.031 -384.101)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M398.351,408.342a12.709,12.709,0,0,0-3.8-3.2c-7.111-4.108-18.637-4.108-25.751,0a12.733,12.733,0,0,0-3.8,3.2c-2.933-3.854-1.665-8.517,3.8-11.672,7.114-4.108,18.64-4.108,25.751,0C400.022,399.828,401.282,404.487,398.351,408.342Z",
    transform: "translate(-317.166 -366.858)",
    fill: "#535359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M397.36,402.875a12.7,12.7,0,0,1-3.8,3.192c-7.111,4.108-18.637,4.108-25.751,0a12.722,12.722,0,0,1-3.8-3.192,12.733,12.733,0,0,1,3.8-3.2c7.114-4.108,18.64-4.108,25.751,0A12.708,12.708,0,0,1,397.36,402.875Z",
    transform: "translate(-316.175 -361.391)",
    fill: "#303033"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2514",
    "data-name": "Group 2514",
    transform: "translate(9.089 8.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M465.562,385.942v31.795c0,8.615-5.685,17.231-17,23.717-22.57,13.113-59.289,13.113-81.939,0-11.319-6.487-16.93-15.1-16.93-23.717V385.942Z",
    transform: "translate(-349.679 -352.482)",
    fill: "#24d2c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M465.562,389.319c-.026,8.544-5.682,17.085-16.988,23.6-22.578,13.151-59.292,13.151-81.933,0-11.056-6.372-16.7-14.7-16.953-23.059v1.628c0,8.613,5.611,17.231,16.93,23.714,22.65,13.113,59.369,13.113,81.939,0,11.319-6.484,17-15.1,17-23.714v-2.169Z",
    transform: "translate(-349.679 -346.196)",
    fill: "#0a8074",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M465.562,391.259c-.026,8.544-5.682,17.088-16.988,23.6-22.578,13.148-59.292,13.148-81.933,0-11.056-6.378-16.7-14.7-16.953-23.059v1.622c0,8.618,5.611,17.233,16.93,23.72,22.65,13.116,59.369,13.116,81.939,0,11.319-6.487,17-15.1,17-23.72v-2.163Z",
    transform: "translate(-349.679 -342.586)",
    fill: "#0a8074",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M465.562,393.2c-.026,8.55-5.682,17.088-16.988,23.6-22.578,13.153-59.292,13.153-81.933,0-11.056-6.372-16.7-14.69-16.953-23.053v1.625c0,8.615,5.611,17.231,16.93,23.714,22.65,13.116,59.369,13.116,81.939,0,11.319-6.484,17-15.1,17-23.714V393.2Z",
    transform: "translate(-349.679 -338.977)",
    fill: "#0a8074",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M465.562,395.139c-.026,8.544-5.682,17.09-16.988,23.594-22.578,13.156-59.292,13.156-81.933,0-11.056-6.366-16.7-14.69-16.953-23.053v1.628c0,8.615,5.611,17.234,16.93,23.714,22.65,13.116,59.369,13.116,81.939,0,11.319-6.481,17-15.1,17-23.714v-2.169Z",
    transform: "translate(-349.679 -335.364)",
    fill: "#0a8074",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M366.647,431.308c22.641,13.153,59.355,13.153,81.933,0,22.641-13.045,22.641-34.247,0-47.283-22.578-13.036-59.292-13.036-81.933,0C344.031,397.061,344.031,418.263,366.647,431.308Z",
    transform: "translate(-349.685 -374.248)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M366.9,427.731c20.862,12.118,54.691,12.118,75.484,0,20.862-12.015,20.862-31.54,0-43.549-20.793-12.017-54.622-12.017-75.484,0C346.073,396.191,346.073,415.716,366.9,427.731Z",
    transform: "translate(-346.717 -372.534)",
    fill: "#24d2c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M367.1,425.023c19.514,11.336,51.146,11.336,70.6,0,19.508-11.231,19.508-29.494,0-40.731-19.454-11.236-51.086-11.236-70.6,0C347.619,395.528,347.619,413.792,367.1,425.023Z",
    transform: "translate(-344.466 -371.239)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M367.253,422.9c18.432,10.7,48.307,10.7,66.674,0,18.43-10.612,18.43-27.863,0-38.47-18.367-10.615-48.241-10.615-66.674,0C348.861,395.033,348.861,412.284,367.253,422.9Z",
    transform: "translate(-342.66 -370.123)",
    fill: "#24d2c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M367.418,420.59c17.3,10.046,45.346,10.046,62.585,0,17.305-9.963,17.305-26.155,0-36.109-17.239-9.963-45.283-9.963-62.585,0C350.153,394.435,350.153,410.627,367.418,420.59Z",
    transform: "translate(-340.78 -369.11)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M367.558,418.7c16.341,9.491,42.831,9.491,59.117,0,16.332-9.408,16.332-24.7,0-34.107-16.286-9.405-42.776-9.405-59.117,0C351.251,394,351.251,409.293,367.558,418.7Z",
    transform: "translate(-339.182 -368.119)",
    fill: "#24d2c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M367.7,416.763c15.388,8.942,40.336,8.942,55.669,0,15.4-8.864,15.4-23.268,0-32.118-15.334-8.867-40.281-8.867-55.669,0C352.337,393.5,352.337,407.9,367.7,416.763Z",
    transform: "translate(-337.601 -367.274)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M367.82,415.081c14.535,8.438,38.1,8.438,52.582,0,14.533-8.367,14.533-21.972,0-30.338-14.487-8.367-38.047-8.367-52.582,0C353.316,393.109,353.316,406.715,367.82,415.081Z",
    transform: "translate(-336.177 -366.393)",
    fill: "#24d2c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M367.953,413.272c13.643,7.92,35.76,7.92,49.357,0,13.637-7.863,13.637-20.63,0-28.481-13.6-7.86-35.715-7.86-49.357,0C354.333,392.642,354.333,405.409,367.953,413.272Z",
    transform: "translate(-334.696 -365.597)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M368.062,411.783c12.884,7.479,33.775,7.479,46.616,0,12.887-7.422,12.887-19.485,0-26.9-12.842-7.422-33.732-7.422-46.616,0C355.2,392.3,355.2,404.361,368.062,411.783Z",
    transform: "translate(-333.435 -364.818)",
    fill: "#24d2c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    d: "M368.161,410.366c12.2,7.079,31.964,7.079,44.118,0,12.2-7.019,12.2-18.435,0-25.454-12.155-7.024-31.921-7.024-44.118,0C355.99,391.931,355.99,403.347,368.161,410.366Z",
    transform: "translate(-332.287 -364.205)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M368.26,409.033c11.52,6.687,30.187,6.687,41.666,0,11.522-6.63,11.522-17.411,0-24.038-11.48-6.635-30.147-6.635-41.666,0C356.766,391.622,356.766,402.4,368.26,409.033Z",
    transform: "translate(-331.157 -363.507)",
    fill: "#24d2c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M368.356,407.666c10.847,6.3,28.438,6.3,39.248,0,10.841-6.243,10.841-16.4,0-22.641-10.81-6.246-28.4-6.246-39.248,0C357.532,391.268,357.532,401.422,368.356,407.666Z",
    transform: "translate(-330.043 -362.909)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M368.444,406.484c10.249,5.949,26.853,5.949,37.068,0,10.243-5.9,10.243-15.491,0-21.388-10.215-5.9-26.819-5.9-37.068,0C358.22,390.993,358.22,400.581,368.444,406.484Z",
    transform: "translate(-329.041 -362.289)",
    fill: "#24d2c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M368.535,405.2c9.62,5.591,25.208,5.591,34.793,0,9.62-5.534,9.62-14.535,0-20.072-9.585-5.537-25.174-5.537-34.793,0C358.938,390.665,358.938,399.666,368.535,405.2Z",
    transform: "translate(-327.996 -361.726)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M368.616,404.153c9.082,5.273,23.812,5.273,32.856,0,9.085-5.228,9.085-13.734,0-18.962-9.044-5.228-23.774-5.228-32.856,0S359.548,398.926,368.616,404.153Z",
    transform: "translate(-327.107 -361.177)",
    fill: "#24d2c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M368.743,402.376c8.189,4.755,21.46,4.755,29.614,0,8.192-4.713,8.192-12.378,0-17.088-8.155-4.713-21.425-4.713-29.614,0C360.571,390,360.571,397.663,368.743,402.376Z",
    transform: "translate(-325.62 -360.278)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M366.647,431.308c22.641,13.153,59.355,13.153,81.933,0,22.641-13.045,22.641-34.247,0-47.283-22.578-13.036-59.292-13.036-81.933,0C344.031,397.061,344.031,418.263,366.647,431.308Z",
    transform: "translate(-349.685 -374.248)",
    opacity: 0.74
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2515",
    "data-name": "Group 2515",
    transform: "translate(2.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M475.643,405.812c-1.592-8.08-7.753-15.91-18.476-22.108-25.19-14.54-66.039-14.54-91.229,0-10.8,6.235-16.972,14.135-18.513,22.268l-.389-.161v4.468h0c.107,9.452,6.4,18.888,18.9,26.1,25.19,14.543,66.039,14.543,91.229,0,12.6-7.272,18.893-16.8,18.893-26.334v-4.234ZM371.274,386.8a8.558,8.558,0,0,1,7.742,0L394.8,395.9c2.13,1.24,2.13,3.237,0,4.474a8.57,8.57,0,0,1-7.748,0l-15.777-9.111C369.138,390.03,369.138,388.026,371.274,386.8Zm-11.2,26.413c-3.026-.006-5.474-1.42-5.474-3.161s2.448-3.164,5.474-3.164h22.314c3.023,0,5.474,1.417,5.474,3.164s-2.451,3.156-5.474,3.156Zm34.73,10.976L379.016,433.3a8.575,8.575,0,0,1-7.742,0c-2.133-1.234-2.133-3.237,0-4.468l15.777-9.109a8.553,8.553,0,0,1,7.748,0C396.934,420.95,396.929,422.951,394.8,424.185Zm11.272-43.864c0-1.744,2.454-3.155,5.483-3.155s5.471,1.412,5.466,3.155l.006,12.887c0,1.741-2.451,3.158-5.471,3.158s-5.483-1.417-5.483-3.158Zm5.483,62.6c-3.029,0-5.483-1.412-5.483-3.158V426.881c0-1.744,2.454-3.161,5.483-3.161s5.471,1.417,5.471,3.161v12.887C417.025,441.514,414.574,442.926,411.554,442.926ZM428.3,395.9,444.08,386.8a8.553,8.553,0,0,1,7.739,0c2.138,1.234,2.138,3.234,0,4.468l-15.777,9.111a8.564,8.564,0,0,1-7.745,0C426.167,399.141,426.167,397.141,428.3,395.9ZM451.82,433.3a8.569,8.569,0,0,1-7.739,0L428.3,424.185c-2.136-1.234-2.136-3.234,0-4.465a8.535,8.535,0,0,1,7.739,0l15.777,9.109C453.958,430.059,453.958,432.062,451.82,433.3ZM463.033,413.2H440.714c-3.02,0-5.474-1.414-5.474-3.156s2.454-3.164,5.474-3.164h22.319c3.023,0,5.471,1.417,5.471,3.164S466.056,413.2,463.033,413.2Z",
    transform: "translate(-347.036 -368.563)",
    fill: "#535359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M457.162,382.205c-25.19-14.546-66.039-14.546-91.229,0s-25.193,38.127,0,52.674,66.039,14.543,91.229,0S482.35,396.751,457.162,382.205Zm-85.893,7.553c-2.136-1.231-2.136-3.229,0-4.466a8.541,8.541,0,0,1,7.742,0l15.783,9.106c2.13,1.234,2.13,3.237,0,4.468a8.535,8.535,0,0,1-7.748,0ZM382.378,411.7H360.065c-3.026,0-5.474-1.417-5.474-3.155s2.448-3.164,5.474-3.164h22.314c3.023,0,5.474,1.411,5.474,3.164S385.4,411.7,382.378,411.7Zm29.171-16.839c-3.029,0-5.483-1.414-5.483-3.158V378.816c0-1.744,2.454-3.158,5.483-3.158s5.471,1.414,5.466,3.158l.006,12.887C417.02,393.447,414.569,394.861,411.549,394.861Zm-32.538,36.933a8.559,8.559,0,0,1-7.742,0c-2.133-1.234-2.133-3.234,0-4.468l15.777-9.111a8.588,8.588,0,0,1,7.748,0c2.136,1.234,2.13,3.237,0,4.468Zm57.026-32.927a8.529,8.529,0,0,1-7.745,0c-2.13-1.231-2.13-3.234,0-4.468l15.783-9.106a8.536,8.536,0,0,1,7.739,0c2.138,1.237,2.138,3.234,0,4.466Zm4.671,6.514h22.319c3.023,0,5.471,1.411,5.471,3.158s-2.448,3.161-5.471,3.161H440.709c-3.02,0-5.474-1.417-5.474-3.161S437.689,405.381,440.709,405.381Zm-29.16,36.045c-3.029,0-5.483-1.417-5.483-3.164V425.381c0-1.75,2.454-3.164,5.483-3.164s5.471,1.414,5.471,3.164v12.881C417.02,440.009,414.569,441.426,411.549,441.426Zm32.527-9.633L428.3,422.682c-2.136-1.231-2.136-3.234,0-4.468a8.57,8.57,0,0,1,7.739,0l15.777,9.111c2.138,1.234,2.138,3.234,0,4.468A8.553,8.553,0,0,1,444.076,431.794Z",
    transform: "translate(-347.031 -371.296)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M398.351,395.534a12.714,12.714,0,0,0-3.8-3.2c-7.111-4.1-18.637-4.1-25.751,0a12.738,12.738,0,0,0-3.8,3.2c-2.933-3.849-1.665-8.52,3.8-11.672,7.114-4.1,18.64-4.1,25.751,0C400.022,387.014,401.282,391.685,398.351,395.534Z",
    transform: "translate(-317.166 -354.05)",
    fill: "#535359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M397.36,390.069a12.75,12.75,0,0,1-3.8,3.2c-7.111,4.1-18.637,4.1-25.751,0a12.774,12.774,0,0,1-3.8-3.2,12.739,12.739,0,0,1,3.8-3.2c7.114-4.1,18.64-4.1,25.751,0A12.715,12.715,0,0,1,397.36,390.069Z",
    transform: "translate(-316.175 -348.586)",
    fill: "#303033"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2520",
    "data-name": "Group 2520",
    transform: "translate(29.369 91.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2517",
    "data-name": "Group 2517",
    transform: "translate(2.626 36.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M437.049,436.748c-1.592-8.075-7.751-15.9-18.479-22.1-25.193-14.549-66.039-14.549-91.232,0-10.793,6.235-16.969,14.126-18.51,22.257l-.383-.161v4.471h0c.107,9.455,6.4,18.888,18.89,26.1,25.193,14.543,66.039,14.543,91.232,0,12.6-7.272,18.9-16.806,18.9-26.34v-4.235ZM332.683,417.734a8.565,8.565,0,0,1,7.745,0l15.777,9.114c2.138,1.228,2.138,3.229,0,4.468a8.57,8.57,0,0,1-7.739,0l-15.783-9.109C330.542,420.971,330.542,418.965,332.683,417.734Zm-11.2,26.413c-3.026,0-5.474-1.42-5.474-3.164s2.448-3.158,5.474-3.158h22.308c3.031,0,5.483,1.417,5.483,3.158s-2.451,3.164-5.483,3.164Zm34.727,10.979-15.777,9.109a8.547,8.547,0,0,1-7.745,0c-2.141-1.231-2.141-3.234,0-4.465l15.783-9.111a8.553,8.553,0,0,1,7.739,0C358.343,451.889,358.343,453.892,356.205,455.126Zm11.281-43.858c0-1.755,2.448-3.167,5.469-3.167s5.477,1.412,5.477,3.167v12.878c0,1.744-2.454,3.158-5.477,3.158s-5.469-1.414-5.469-3.158Zm5.469,62.6c-3.02,0-5.469-1.414-5.469-3.164V457.825c0-1.744,2.448-3.161,5.469-3.161s5.477,1.417,5.477,3.161v12.884C378.431,472.453,375.977,473.867,372.954,473.867Zm16.755-47.019,15.78-9.114a8.547,8.547,0,0,1,7.736,0c2.141,1.231,2.141,3.237,0,4.474l-15.777,9.109a8.57,8.57,0,0,1-7.739,0C387.574,430.077,387.574,428.076,389.709,426.848Zm23.517,37.387a8.529,8.529,0,0,1-7.736,0l-15.78-9.109c-2.136-1.234-2.136-3.237,0-4.465a8.535,8.535,0,0,1,7.739,0l15.777,9.109C415.367,461,415.367,463,413.226,464.235Zm11.21-20.091H402.123c-3.026,0-5.474-1.417-5.474-3.161s2.448-3.158,5.474-3.158h22.314c3.026,0,5.477,1.417,5.477,3.158S427.462,444.144,424.436,444.144Z",
    transform: "translate(-308.444 -399.504)",
    fill: "#535359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M418.571,413.144c-25.193-14.543-66.039-14.543-91.232,0s-25.193,38.13,0,52.674,66.039,14.549,91.232,0S443.767,427.69,418.571,413.144ZM332.684,420.7c-2.141-1.234-2.141-3.234,0-4.468a8.547,8.547,0,0,1,7.745,0l15.777,9.111c2.138,1.231,2.138,3.232,0,4.471a8.57,8.57,0,0,1-7.739,0Zm11.1,21.942H321.479c-3.026,0-5.474-1.412-5.474-3.161s2.448-3.158,5.474-3.158h22.308c3.031,0,5.483,1.414,5.483,3.158S346.818,442.642,343.787,442.642Zm29.168-16.834c-3.02,0-5.469-1.423-5.469-3.167V409.76c0-1.747,2.448-3.158,5.469-3.158s5.477,1.412,5.477,3.158v12.881C378.432,424.385,375.978,425.808,372.955,425.808Zm-32.527,36.925a8.53,8.53,0,0,1-7.745,0c-2.141-1.231-2.141-3.234,0-4.471l15.783-9.1a8.536,8.536,0,0,1,7.739,0c2.138,1.231,2.138,3.229,0,4.463Zm57.021-32.918a8.57,8.57,0,0,1-7.739,0c-2.136-1.24-2.136-3.24,0-4.471l15.78-9.111a8.529,8.529,0,0,1,7.736,0c2.141,1.234,2.141,3.234,0,4.468Zm4.674,6.508h22.314c3.026,0,5.477,1.414,5.477,3.155s-2.451,3.164-5.477,3.164H402.123c-3.026,0-5.474-1.412-5.474-3.164S399.1,436.322,402.123,436.322Zm-29.168,36.043c-3.02,0-5.469-1.417-5.469-3.158V456.317c0-1.741,2.448-3.153,5.469-3.153s5.477,1.412,5.477,3.153v12.889C378.432,470.948,375.978,472.365,372.955,472.365Zm32.535-9.632-15.78-9.111c-2.136-1.234-2.136-3.232,0-4.463a8.535,8.535,0,0,1,7.739,0l15.777,9.1c2.141,1.237,2.141,3.24,0,4.471A8.512,8.512,0,0,1,405.49,462.733Z",
    transform: "translate(-308.445 -402.236)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M359.759,426.469a12.611,12.611,0,0,0-3.8-3.192c-7.114-4.1-18.643-4.1-25.751,0a12.623,12.623,0,0,0-3.8,3.192c-2.933-3.851-1.665-8.511,3.8-11.664,7.108-4.1,18.637-4.1,25.751,0C361.433,417.958,362.692,422.617,359.759,426.469Z",
    transform: "translate(-278.576 -384.99)",
    fill: "#535359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M358.769,421a12.589,12.589,0,0,1-3.8,3.2c-7.114,4.108-18.643,4.108-25.751,0a12.6,12.6,0,0,1-3.8-3.2,12.623,12.623,0,0,1,3.8-3.192c7.108-4.1,18.637-4.1,25.751,0A12.61,12.61,0,0,1,358.769,421Z",
    transform: "translate(-277.585 -379.525)",
    fill: "#303033"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2518",
    "data-name": "Group 2518",
    transform: "translate(9.072 7.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M427.265,404.077V435.96c0,8.638-5.694,17.272-17.04,23.776-22.634,13.153-59.448,13.153-82.157,0C316.72,453.232,311.1,444.6,311.1,435.96V404.077Z",
    transform: "translate(-311.087 -370.535)",
    fill: "#e66171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M427.265,407.454c-.02,8.569-5.692,17.14-17.029,23.664-22.631,13.179-59.442,13.179-82.148,0C317.009,424.724,311.347,416.384,311.1,408v1.624c0,8.646,5.623,17.284,16.971,23.779,22.709,13.156,59.523,13.156,82.157,0,11.346-6.495,17.04-15.132,17.04-23.779v-2.169Z",
    transform: "translate(-311.087 -364.224)",
    fill: "#9c251f",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M427.265,409.394c-.02,8.569-5.692,17.138-17.029,23.661-22.631,13.188-59.442,13.188-82.148,0-11.079-6.388-16.742-14.731-16.991-23.116v1.632c0,8.638,5.623,17.275,16.971,23.77,22.709,13.159,59.523,13.159,82.157,0,11.346-6.495,17.04-15.132,17.04-23.77v-2.177Z",
    transform: "translate(-311.087 -360.599)",
    fill: "#9c251f",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M427.265,411.334c-.02,8.572-5.692,17.132-17.029,23.658-22.631,13.187-59.442,13.187-82.148,0-11.079-6.383-16.742-14.725-16.991-23.113v1.629c0,8.641,5.623,17.281,16.971,23.779,22.709,13.147,59.523,13.147,82.157,0,11.346-6.5,17.04-15.138,17.04-23.779v-2.174Z",
    transform: "translate(-311.087 -356.974)",
    fill: "#9c251f",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M427.265,413.274c-.02,8.572-5.692,17.135-17.029,23.664-22.631,13.184-59.442,13.184-82.148,0-11.079-6.391-16.742-14.734-16.991-23.119v1.632c0,8.638,5.623,17.275,16.971,23.776,22.709,13.147,59.523,13.147,82.157,0,11.346-6.5,17.04-15.138,17.04-23.776v-2.177Z",
    transform: "translate(-311.087 -353.348)",
    fill: "#9c251f",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M328.095,449.585c22.706,13.185,59.517,13.185,82.148,0,22.709-13.073,22.709-34.33,0-47.394-22.631-13.076-59.442-13.076-82.148,0C305.426,415.255,305.426,436.512,328.095,449.585Z",
    transform: "translate(-311.094 -392.385)",
    fill: "#9c251f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M328.347,446c20.919,12.152,54.83,12.152,75.679,0,20.919-12.046,20.919-31.627,0-43.662-20.85-12.046-54.761-12.046-75.679,0C307.469,414.374,307.469,433.956,328.347,446Z",
    transform: "translate(-308.113 -390.663)",
    fill: "#e31b25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M328.538,443.288c19.567,11.363,51.284,11.363,70.785,0,19.562-11.268,19.562-29.582,0-40.836-19.5-11.268-51.218-11.268-70.785,0C309.019,413.706,309.019,432.02,328.538,443.288Z",
    transform: "translate(-305.851 -389.364)",
    fill: "#9c251f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M328.7,441.148c18.477,10.729,48.432,10.729,66.846,0,18.477-10.634,18.477-27.935,0-38.564-18.414-10.643-48.369-10.643-66.846,0C310.255,413.212,310.255,430.513,328.7,441.148Z",
    transform: "translate(-304.042 -388.242)",
    fill: "#e31b25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M328.865,438.839c17.341,10.069,45.457,10.069,62.747,0,17.344-9.986,17.344-26.223,0-36.2-17.29-9.989-45.406-9.989-62.747,0C311.547,412.616,311.547,428.853,328.865,438.839Z",
    transform: "translate(-302.156 -387.227)",
    fill: "#9c251f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M329,436.943c16.383,9.515,42.939,9.515,59.27,0,16.38-9.429,16.38-24.763,0-34.189-16.331-9.438-42.887-9.438-59.27,0C312.647,412.181,312.647,427.514,329,436.943Z",
    transform: "translate(-300.551 -386.235)",
    fill: "#e31b25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M329.139,435c15.425,8.962,40.434,8.962,55.811,0,15.434-8.887,15.434-23.323,0-32.207-15.376-8.882-40.386-8.882-55.811,0C313.734,411.676,313.734,426.112,329.139,435Z",
    transform: "translate(-298.962 -385.383)",
    fill: "#9c251f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M329.263,433.315c14.567,8.46,38.188,8.46,52.715,0,14.573-8.394,14.573-22.032,0-30.42-14.527-8.388-38.148-8.388-52.715,0C314.712,411.283,314.712,424.921,329.263,433.315Z",
    transform: "translate(-297.533 -384.499)",
    fill: "#e31b25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M329.387,431.492c13.681,7.946,35.856,7.946,49.488,0,13.681-7.877,13.681-20.678,0-28.552-13.632-7.877-35.807-7.877-49.488,0C315.732,410.814,315.732,423.614,329.387,431.492Z",
    transform: "translate(-296.046 -383.701)",
    fill: "#9c251f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M329.492,429.994c12.926,7.5,33.865,7.5,46.746,0,12.915-7.438,12.915-19.527,0-26.966-12.88-7.436-33.819-7.436-46.746,0C316.6,410.467,316.6,422.556,329.492,429.994Z",
    transform: "translate(-294.78 -382.915)",
    fill: "#e31b25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M329.6,428.581c12.229,7.1,32.046,7.1,44.233,0,12.226-7.043,12.226-18.483,0-25.523-12.186-7.037-32-7.037-44.233,0C317.389,410.1,317.389,421.538,329.6,428.581Z",
    transform: "translate(-293.626 -382.301)",
    fill: "#9c251f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M329.691,427.243c11.547,6.7,30.265,6.7,41.777,0,11.549-6.644,11.549-17.456,0-24.1-11.512-6.647-30.23-6.647-41.777,0C318.165,409.787,318.165,420.6,329.691,427.243Z",
    transform: "translate(-292.494 -381.601)",
    fill: "#e31b25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M329.789,425.878c10.875,6.314,28.509,6.314,39.347,0,10.875-6.268,10.875-16.449,0-22.712-10.838-6.254-28.472-6.254-39.347,0C318.931,409.429,318.931,419.61,329.789,425.878Z",
    transform: "translate(-291.375 -381.001)",
    fill: "#9c251f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M329.872,424.688c10.276,5.961,26.923,5.961,37.164,0,10.276-5.915,10.276-15.531,0-21.441-10.241-5.918-26.888-5.918-37.164,0C319.622,409.157,319.622,418.773,329.872,424.688Z",
    transform: "translate(-290.368 -380.379)",
    fill: "#e31b25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M329.964,423.4c9.645,5.6,25.276,5.6,34.886,0,9.639-5.557,9.639-14.576,0-20.121-9.61-5.56-25.242-5.56-34.886,0C320.34,408.825,320.34,417.845,329.964,423.4Z",
    transform: "translate(-289.319 -379.816)",
    fill: "#9c251f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M330.041,422.348c9.105,5.287,23.865,5.287,32.944,0,9.111-5.241,9.111-13.77,0-19.011-9.079-5.241-23.839-5.241-32.944,0C320.953,408.579,320.953,417.107,330.041,422.348Z",
    transform: "translate(-288.423 -379.262)",
    fill: "#e31b25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M330.171,420.574c8.21,4.759,21.515,4.759,29.694,0,8.2-4.73,8.2-12.407,0-17.138-8.179-4.73-21.484-4.73-29.694,0S321.973,415.843,330.171,420.574Z",
    transform: "translate(-286.933 -378.362)",
    fill: "#9c251f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M328.095,449.585c22.706,13.185,59.517,13.185,82.148,0,22.709-13.073,22.709-34.33,0-47.394-22.631-13.076-59.442-13.076-82.148,0C305.426,415.255,305.426,436.512,328.095,449.585Z",
    transform: "translate(-311.094 -392.385)",
    opacity: 0.68
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2519",
    "data-name": "Group 2519",
    transform: "translate(2.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M437.049,423.947c-1.592-8.077-7.751-15.912-18.479-22.1-25.193-14.549-66.039-14.549-91.232,0-10.793,6.229-16.969,14.123-18.51,22.257l-.383-.158v4.468h0c.107,9.455,6.4,18.888,18.89,26.1,25.193,14.549,66.039,14.549,91.232,0,12.6-7.277,18.9-16.8,18.9-26.334v-4.234ZM332.683,404.933a8.53,8.53,0,0,1,7.745,0l15.777,9.106c2.138,1.237,2.138,3.237,0,4.468a8.518,8.518,0,0,1-7.739,0L332.683,409.4C330.542,408.164,330.542,406.164,332.683,404.933Zm-11.2,26.4c-3.026,0-5.474-1.412-5.474-3.155s2.448-3.164,5.474-3.164h22.308c3.031,0,5.483,1.414,5.483,3.164s-2.451,3.155-5.483,3.155Zm34.727,10.982-15.777,9.111a8.547,8.547,0,0,1-7.745,0c-2.141-1.237-2.141-3.234,0-4.468l15.783-9.111a8.561,8.561,0,0,1,7.739,0C358.343,439.091,358.343,441.088,356.205,442.319Zm11.281-43.864c0-1.741,2.448-3.156,5.469-3.156s5.477,1.414,5.477,3.156v12.887c0,1.741-2.454,3.158-5.477,3.158s-5.469-1.417-5.469-3.158Zm5.469,62.61c-3.02,0-5.469-1.417-5.469-3.164V445.015c0-1.744,2.448-3.155,5.469-3.155s5.477,1.412,5.477,3.155V457.9C378.431,459.649,375.977,461.066,372.954,461.066Zm16.755-47.028,15.78-9.106a8.512,8.512,0,0,1,7.736,0c2.141,1.231,2.141,3.232,0,4.466l-15.777,9.109a8.518,8.518,0,0,1-7.739,0C387.574,417.276,387.574,415.275,389.709,414.038Zm23.517,37.392a8.529,8.529,0,0,1-7.736,0l-15.78-9.111c-2.136-1.231-2.136-3.229,0-4.468a8.569,8.569,0,0,1,7.739,0l15.777,9.111C415.367,448.2,415.367,450.194,413.226,451.431Zm11.21-20.093H402.123c-3.026,0-5.474-1.412-5.474-3.158s2.448-3.161,5.474-3.161h22.314c3.026,0,5.477,1.414,5.477,3.161S427.462,431.337,424.436,431.337Z",
    transform: "translate(-308.444 -386.702)",
    fill: "#535359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M418.571,400.339c-25.193-14.54-66.039-14.54-91.232,0s-25.193,38.125,0,52.674,66.039,14.543,91.232,0S443.767,414.882,418.571,400.339Zm-85.887,7.553c-2.141-1.234-2.141-3.231,0-4.468a8.582,8.582,0,0,1,7.745,0l15.777,9.106c2.138,1.242,2.138,3.246,0,4.474a8.536,8.536,0,0,1-7.739,0Zm11.1,21.945H321.479c-3.026,0-5.474-1.417-5.474-3.161s2.448-3.161,5.474-3.161h22.308c3.031,0,5.483,1.414,5.483,3.161S346.818,429.836,343.787,429.836Zm29.168-16.842c-3.02,0-5.469-1.411-5.469-3.158V396.946c0-1.741,2.448-3.153,5.469-3.153s5.477,1.412,5.477,3.153v12.889C378.432,411.583,375.978,412.994,372.955,412.994Zm-32.527,36.93a8.564,8.564,0,0,1-7.745,0c-2.141-1.234-2.141-3.232,0-4.468l15.783-9.111a8.553,8.553,0,0,1,7.739,0c2.138,1.237,2.138,3.24,0,4.471ZM397.449,417a8.536,8.536,0,0,1-7.739,0c-2.136-1.228-2.136-3.232,0-4.474l15.78-9.106a8.564,8.564,0,0,1,7.736,0c2.141,1.237,2.141,3.234,0,4.468Zm4.674,6.508h22.314c3.026,0,5.477,1.417,5.477,3.164s-2.451,3.161-5.477,3.161H402.123c-3.026,0-5.474-1.417-5.474-3.161S399.1,423.511,402.123,423.511Zm-29.168,36.043c-3.02,0-5.469-1.411-5.469-3.155V443.512c0-1.741,2.448-3.164,5.469-3.164s5.477,1.423,5.477,3.164V456.4C378.432,458.143,375.978,459.554,372.955,459.554Zm32.535-9.63-15.78-9.109c-2.136-1.231-2.136-3.234,0-4.471a8.553,8.553,0,0,1,7.739,0l15.777,9.111c2.141,1.237,2.141,3.234,0,4.468A8.529,8.529,0,0,1,405.49,449.924Z",
    transform: "translate(-308.445 -389.433)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M359.759,413.671a12.7,12.7,0,0,0-3.8-3.2c-7.114-4.1-18.643-4.1-25.751,0a12.716,12.716,0,0,0-3.8,3.2c-2.933-3.851-1.665-8.514,3.8-11.672,7.108-4.1,18.637-4.1,25.751,0C361.433,405.157,362.692,409.82,359.759,413.671Z",
    transform: "translate(-278.576 -372.192)",
    fill: "#535359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M358.769,408.2a12.744,12.744,0,0,1-3.8,3.2c-7.114,4.1-18.643,4.1-25.751,0a12.757,12.757,0,0,1-3.8-3.2,12.716,12.716,0,0,1,3.8-3.2c7.108-4.1,18.637-4.1,25.751,0A12.7,12.7,0,0,1,358.769,408.2Z",
    transform: "translate(-277.585 -366.725)",
    fill: "#303033"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2525",
    "data-name": "Group 2525",
    transform: "matrix(1, 0.017, -0.017, 1, -39.654, -215.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2526",
    "data-name": "Group 2526",
    transform: "translate(280.706 257.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M367.508,334.354V477.585c.009.324.012.646,0,.967v1.12h-.087c-1.327,11.352-16.355,20.856-36.634,22.229-23.118,1.568-44.319-8.015-47.349-21.4-.063-.276-.114-.556-.162-.832h-.189V477.7c-.009-.306-.012-.616,0-.922V333.471c-.312-12.216,15.262-22.775,36.731-24.229,23.112-1.568,44.313,8.012,47.343,21.391A14.476,14.476,0,0,1,367.508,334.354Z",
    transform: "translate(-283.077 -268.005)",
    fill: "#747474",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M360.974,334.991V464.921c.009.294.012.586,0,.88v1.015H360.9c-1.207,10.3-14.838,18.916-33.235,20.166-20.97,1.42-40.2-7.27-42.953-19.412-.057-.252-.105-.5-.147-.754h-.171v-1.787c-.009-.279-.012-.562,0-.835V334.189c-.285-11.081,13.844-20.661,33.322-21.979,20.964-1.42,40.2,7.27,42.944,19.406A12.989,12.989,0,0,1,360.974,334.991Z",
    transform: "translate(-280.463 -262.03)",
    fill: "#616161",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M287.514,310.415h57.809v6.892h-.009c.526,8.514-10.234,15.931-25.136,16.943-15.829,1.072-30.352-5.49-32.424-14.652a9.642,9.642,0,0,1-.24-2.465Z",
    transform: "translate(-274.2 -265.319)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M312.669,304.731c-15.829,1.075-26.986,9.376-24.913,18.538s16.595,15.724,32.427,14.652,26.982-9.375,24.907-18.538S328.5,303.658,312.669,304.731Z",
    transform: "translate(-274.204 -276.936)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M313.175,300.8c-16.391,1.616-27.937,10.6-25.793,20.06s17.181,15.823,33.571,14.208,27.931-10.6,25.784-20.061S329.56,299.192,313.175,300.8Z",
    transform: "translate(-274.968 -285.07)",
    fill: "#ca4e02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M344.892,303.607v16.829h-.009c.519,8.436-10.141,15.79-24.91,16.79-15.688,1.063-30.079-5.439-32.133-14.52a9.6,9.6,0,0,1-.24-2.444V303.144c2.871,8.727,17.039,14.841,32.439,13.8C332.826,316.075,342.586,310.529,344.892,303.607Z",
    transform: "translate(-274.027 -279.884)",
    fill: "#b13305",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M312.805,296.667c-15.97,1.084-27.223,9.457-25.133,18.7s16.739,15.865,32.712,14.781,27.22-9.454,25.127-18.7S328.773,295.586,312.805,296.667Z",
    transform: "translate(-274.373 -293.089)",
    fill: "#5c1c07",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M309.569,297.8c-12.673.859-21.6,7.5-19.94,14.835s13.28,12.589,25.952,11.73,21.6-7.5,19.937-14.838S322.236,296.944,309.569,297.8Z",
    transform: "translate(-270.353 -290.766)",
    fill: "#892604",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M304.064,297.8a32.906,32.906,0,0,0-11.886,2.925V321.2a35.892,35.892,0,0,0,17.9,3.171,32.752,32.752,0,0,0,11.988-2.982V301.019A35.851,35.851,0,0,0,304.064,297.8Z",
    transform: "translate(-264.848 -290.765)",
    fill: "#b13305",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M314.47,295.526c-17.667,1.2-30.118,10.463-27.8,20.688s18.517,17.55,36.187,16.352,30.115-10.463,27.8-20.688S332.134,294.331,314.47,295.526Z",
    transform: "translate(-276.44 -295.398)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M344.89,305.333l-.009,3.619c-.76,12.673-42.725,25.391-57.284,5.733v-5.628C293.627,327.388,338.658,324.027,344.89,305.333Z",
    transform: "translate(-274.024 -275.499)",
    fill: "#ca4e02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M346.827,305.916l-.009,3.766c-.751,12.52-40.151,25.082-57.1,8.814a7.779,7.779,0,0,1-2.508-5.778V309.79C293.484,328.866,340.344,325.37,346.827,305.916Z",
    transform: "translate(-274.8 -274.331)",
    fill: "#892604",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M350.465,302.9V321.7h-.009c.58,9.421-11.328,17.631-27.82,18.748-17.517,1.189-33.586-6.072-35.881-16.21a10.781,10.781,0,0,1-.267-2.73V302.386c3.207,9.745,19.024,16.574,36.226,15.409C336.993,316.828,347.888,310.635,350.465,302.9Z",
    transform: "translate(-276.257 -281.402)",
    fill: "#535359",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M311.954,296.564c-15.1.994-25.742,8.679-23.766,17.156s15.829,14.559,30.932,13.565,25.739-8.676,23.76-17.159S327.05,295.573,311.954,296.564Z",
    transform: "translate(-273.314 -293.277)",
    fill: "#373737",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M311.955,296.408c-15.105,1.024-25.745,8.946-23.769,17.691l.063.252c-.421-8.087,9.82-15.117,23.995-16.078,14.958-1.012,28.688,5.12,30.871,13.73a9.373,9.373,0,0,0-.222-1.613C340.913,301.648,327.06,295.387,311.955,296.408Z",
    transform: "translate(-273.318 -293.595)",
    fill: "#084304",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M360.974,330.942V437.935c.009.242.012.482,0,.725v.836H360.9c-1.207,8.48-14.838,15.577-33.235,16.606-20.97,1.17-40.2-5.987-42.953-15.985-.057-.208-.105-.415-.147-.621h-.171v-1.471c-.009-.23-.012-.462,0-.687V330.282c-.285-9.125,13.844-17.014,33.322-18.1,20.964-1.17,40.2,5.987,42.944,15.98A8.879,8.879,0,0,1,360.974,330.942Z",
    transform: "translate(-280.463 -231.122)",
    fill: "#545454",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2524",
    "data-name": "Group 2524",
    transform: "translate(239.733 342.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2202-2",
    "data-name": "Path 2202",
    d: "M352.907,329.982V448.445c.008.268.01.534,0,.8v.926h-.072c-1.1,9.389-13.527,17.25-30.3,18.385-19.12,1.3-36.655-6.629-39.161-17.7-.052-.229-.094-.46-.134-.688h-.157v-1.629c-.007-.253-.01-.509,0-.763V329.252c-.258-10.1,12.622-18.837,30.379-20.039,19.115-1.3,36.65,6.627,39.156,17.692A11.971,11.971,0,0,1,352.907,329.982Z",
    transform: "translate(-283.077 -275.107)",
    fill: "#464646",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203-2",
    "data-name": "Path 2203",
    d: "M347.73,331.025V438.487c.008.243.01.484,0,.728v.84h-.065c-1,8.517-12.272,15.645-27.488,16.678-17.344,1.175-33.253-6.013-35.525-16.055-.047-.209-.087-.417-.122-.623h-.142v-1.478c-.008-.231-.01-.464,0-.691V330.362c-.236-9.165,11.45-17.088,27.56-18.179,17.339-1.175,33.248,6.013,35.518,16.05A10.743,10.743,0,0,1,347.73,331.025Z",
    transform: "translate(-281.141 -270.681)",
    fill: "#393939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204-2",
    "data-name": "Path 2204",
    d: "M287.514,310.415h47.812v5.7h-.007c.435,7.042-8.465,13.176-20.789,14.013-13.092.887-25.1-4.54-26.817-12.118a7.975,7.975,0,0,1-.2-2.039Z",
    transform: "translate(-276.501 -273.118)",
    fill: "#484848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205-2",
    "data-name": "Path 2205",
    d: "M308.318,304.711c-13.092.889-22.319,7.754-20.605,15.332s13.725,13,26.82,12.118,22.316-7.754,20.6-15.332S321.41,303.824,308.318,304.711Z",
    transform: "translate(-276.504 -281.722)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206-2",
    "data-name": "Path 2206",
    d: "M308.671,300.762c-13.556,1.336-23.106,8.768-21.333,16.591S301.547,330.44,315.1,329.1s23.1-8.765,21.325-16.592S322.222,299.428,308.671,300.762Z",
    transform: "translate(-277.071 -287.748)",
    fill: "#ca4e02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207-2",
    "data-name": "Path 2207",
    d: "M334.984,303.527v13.919h-.007c.43,6.977-8.388,13.06-20.6,13.887-12.975.879-24.877-4.5-26.576-12.009a7.939,7.939,0,0,1-.2-2.022V303.144c2.375,7.218,14.093,12.275,26.83,11.413C325,313.839,333.077,309.252,334.984,303.527Z",
    transform: "translate(-276.373 -283.906)",
    fill: "#b13305",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210-2",
    "data-name": "Path 2210",
    d: "M308.416,296.647c-13.209.9-22.515,7.821-20.786,15.466s13.844,13.122,27.056,12.225,22.513-7.819,20.782-15.466S321.622,295.753,308.416,296.647Z",
    transform: "translate(-276.63 -293.688)",
    fill: "#5c1c07",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211-2",
    "data-name": "Path 2211",
    d: "M306.086,297.788c-10.481.71-17.866,6.207-16.492,12.27s10.983,10.412,21.465,9.7,17.863-6.207,16.49-12.272S316.563,297.077,306.086,297.788Z",
    transform: "translate(-273.652 -291.967)",
    fill: "#892604",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212-2",
    "data-name": "Path 2212",
    d: "M302.009,297.787a27.216,27.216,0,0,0-9.831,2.419v16.929a29.685,29.685,0,0,0,14.8,2.623,27.089,27.089,0,0,0,9.915-2.466V300.447A29.651,29.651,0,0,0,302.009,297.787Z",
    transform: "translate(-269.574 -291.966)",
    fill: "#b13305",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213-2",
    "data-name": "Path 2213",
    d: "M309.615,295.5c-14.612.991-24.91,8.653-22.995,17.111s15.315,14.515,29.929,13.524,24.907-8.653,22.992-17.111S324.224,294.516,309.615,295.5Z",
    transform: "translate(-278.161 -295.398)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214-2",
    "data-name": "Path 2214",
    d: "M334.982,305.333l-.007,2.993c-.628,10.482-35.336,21-47.378,4.741v-4.655C292.584,323.574,329.828,320.794,334.982,305.333Z",
    transform: "translate(-276.371 -280.658)",
    fill: "#ca4e02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215-2",
    "data-name": "Path 2215",
    d: "M336.518,305.916l-.008,3.115c-.621,10.355-33.208,20.744-47.226,7.29a6.434,6.434,0,0,1-2.074-4.779V309.12C292.4,324.9,331.155,322.006,336.518,305.916Z",
    transform: "translate(-276.946 -279.793)",
    fill: "#892604",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216-2",
    "data-name": "Path 2216",
    d: "M339.4,302.813v15.543h-.007c.479,7.791-9.369,14.582-23.01,15.506-14.488.984-27.778-5.022-29.676-13.407a8.917,8.917,0,0,1-.221-2.258V302.386c2.653,8.06,15.735,13.708,29.962,12.744C328.258,314.33,337.269,309.209,339.4,302.813Z",
    transform: "translate(-278.025 -285.031)",
    fill: "#3663f6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219-2",
    "data-name": "Path 2219",
    d: "M307.8,296.545c-12.491.822-21.291,7.178-19.656,14.19s13.092,12.041,25.583,11.219,21.288-7.175,19.652-14.192S320.289,295.726,307.8,296.545Z",
    transform: "translate(-275.846 -293.827)",
    fill: "#0235be",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220-2",
    "data-name": "Path 2220",
    d: "M307.8,296.389c-12.493.847-21.293,7.4-19.659,14.632l.052.209c-.348-6.689,8.122-12.5,19.845-13.3,12.372-.837,23.727,4.235,25.533,11.356a7.756,7.756,0,0,0-.184-1.334C331.755,300.723,320.3,295.544,307.8,296.389Z",
    transform: "translate(-275.848 -294.063)",
    fill: "#084304",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M347.73,329.16v96.9c.008.22.01.437,0,.656v.757h-.065c-1,7.679-12.272,14.107-27.488,15.038-17.344,1.059-33.253-5.422-35.525-14.476-.047-.188-.087-.376-.122-.562h-.142v-1.332c-.008-.208-.01-.419,0-.623V328.562c-.236-8.264,11.45-15.408,27.56-16.391,17.339-1.059,33.248,5.422,35.518,14.472A8.769,8.769,0,0,1,347.73,329.16Z",
    transform: "translate(-281.141 -254.537)",
    fillRule: "evenodd",
    opacity: 0.33
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2431",
    "data-name": "Group 2431",
    transform: "translate(382 77.783)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -191.32, -31.07)",
    filter: "url(#Rectangle_1128)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1128-2",
    "data-name": "Rectangle 1128",
    width: 267,
    height: 72,
    rx: 36,
    transform: "translate(193.32 31.29)",
    fill: "#343434"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(21 19.217)",
    fill: "#24d2c1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(69 19.217)",
    fill: "#ff8b00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(117 19.217)",
    fill: "#fe0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(165 19.217)",
    fill: "#ee6575"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(213 19.217)",
    fill: "#b8b8b8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.88ca06081381df5fc9dce7fccc3245ed.svg";
export { ForwardRef as ReactComponent };